import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { withFallback } from '@/lib/searchParams'
import { AssignmentsPage } from '@/pages/assignments/AssignmentsPage.tsx'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'

const assignmentsSearchZod = z.object({
  region_id: z.string().optional(),
  assignment_type: withFallback(z.enum(['region', 'global']), 'region'),
  limit: withFallback(z.number(), 50),
})

export const Route = createFileRoute('/assignments/')({
  component: withErrorBoundary(AssignmentsPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  validateSearch: assignmentsSearchZod,
})
